import React from 'react';
import { Sparkles, Handshake, CheckCircle, Camera, User, Upload, Link } from 'lucide-react';

/**
 * MVP Sprint Item 4 — distinct chip per evidence source.
 * Renders a small badge next to the filename in EvidenceTab rows.
 */
const KIND_MAP = {
  interview_record:   { label: 'Generated',       cls: 'bg-slate-100 text-slate-700 border-slate-200',   Icon: Sparkles },
  observation_record: { label: 'Generated',       cls: 'bg-slate-100 text-slate-700 border-slate-200',   Icon: Sparkles },
  mediation_record:   { label: 'Mediation Record', cls: 'bg-violet-100 text-violet-700 border-violet-200', Icon: Handshake },
  // future synthetic outcome kind reserved for Phase 9+; treated as Outcome chip if seen
  mediation_outcome:  { label: 'Outcome',          cls: 'bg-emerald-100 text-emerald-700 border-emerald-200', Icon: CheckCircle },
  witness_statement:  { label: 'Witness',          cls: 'bg-amber-100 text-amber-800 border-amber-200',   Icon: User },
  external_artifact:  { label: 'External',         cls: 'bg-stone-100 text-stone-700 border-stone-200',   Icon: Link },
  prior_review:       { label: 'External',         cls: 'bg-stone-100 text-stone-700 border-stone-200',   Icon: Link },
  other:              { label: 'External',         cls: 'bg-stone-100 text-stone-700 border-stone-200',   Icon: Link },
};

function resolve(kind) {
  if (!kind) return { label: 'Uploaded', cls: 'bg-blue-50 text-blue-700 border-blue-200', Icon: Upload };
  if (KIND_MAP[kind]) return KIND_MAP[kind];
  if (kind.endsWith('_snapshot')) {
    return { label: 'Snapshot', cls: 'bg-sky-100 text-sky-700 border-sky-200', Icon: Camera };
  }
  // document_*, image, audio, video, chat_excerpt, email_thread, screenshot → "Uploaded"
  return { label: 'Uploaded', cls: 'bg-blue-50 text-blue-700 border-blue-200', Icon: Upload };
}

export function EvidenceKindBadge({ kind, className = '' }) {
  const { label, cls, Icon } = resolve(kind);
  return (
    <span
      data-testid={`tf-evidence-kind-badge-${kind || 'unknown'}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${cls} ${className}`}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}

export default EvidenceKindBadge;
